import React from 'react';

import './../styles/product-images.css';

function ProductImages({ showImageInfo = true, selectedColor, images }) {
  const productImages = images?.length ? images : window?.conspire_product?.images;

  return (
    <section className="product-images-container">
      {productImages.map((image, index) => {
        const isSelected = image?.includes(selectedColor.color);

        return (
          <div key={index} className={`product-image-container ${isSelected ? 'is-selected' : ''}`}>
            <img src={image} alt="Product Image" />
          </div>
        )
      })}
      {showImageInfo && (
        <p className="product-images-info">REPRESENTATIVE IMAGE SHOWN</p>
      )}
    </section>
  )
}

export default ProductImages
